import { render, staticRenderFns } from "./BetslipFooterSingle.vue?vue&type=template&id=f7a18cd2&scoped=true"
import script from "./BetslipFooterSingle.vue?vue&type=script&lang=js"
export * from "./BetslipFooterSingle.vue?vue&type=script&lang=js"
import style0 from "./BetslipFooterSingle.vue?vue&type=style&index=0&id=f7a18cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a18cd2",
  null
  
)

export default component.exports